import { useState, useEffect } from "react";
import ReactGA from 'react-ga4';
import { Tabs, Tab } from "@mui/material";
import { TabPanel, TabContext } from "@mui/lab";
import Messages from './components/Messages';
import TandC from "./components/TandC";


const SystemMessages = () => {
  const [value, setValue] = useState("1");

    useEffect(() => {
      ReactGA.send({
        hitType: "pageview",
        page: "/systemmessages",
        title: "System Messages",
      });
    }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{width: '100%'}}>
      <TabContext value={value}>
        <Tabs
          value={value}
          onChange={handleChange}
          centered
        >
          <Tab label="System Messages" value="1" />
          <Tab label="T&C's" value="2" />
        </Tabs>
        <TabPanel value="1" index={0}>
          <Messages />
        </TabPanel>
        <TabPanel value="2" index={1}>
          <TandC />
        </TabPanel>
      </TabContext>
    </div>
  );
};

export default SystemMessages;
